exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form__label[data-v-c1f1c2a2] {\n  margin-bottom: 1rem;\n  display: block;\n}\n.form__multiselect[data-v-c1f1c2a2] {\n  -webkit-box-flex: 0;\n      -ms-flex: 0 0 70%;\n          flex: 0 0 70%;\n}\n.form__row[data-v-c1f1c2a2] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 1rem;\n}\n.form__number[data-v-c1f1c2a2]:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}", ""]);

// exports
